/* src/app/components/analytics/facts-and-issues/facts-and-issues.component.scss */
.add-button {
  margin-top: 10px;
  margin-left: 20px;
  z-index: 10;
  margin-bottom: -10px;
}
.item-description {
  color: grey;
}
:host-context(.dark-theme) .item-description {
  color: #a7a7a7;
}
[matListItemMeta] {
  margin: auto !important;
  margin-right: 10px !important;
}
.mat-mdc-card .mat-mdc-card-actions {
  --justify-content: right;
}
/*# sourceMappingURL=facts-and-issues.component.css.map */
